import React from 'react';
import {
  AlertTriangle,
  ArrowDownLeft,
  ArrowUpRight,
  Calendar,
  IndianRupee,
  TrendingUp,
  Wallet,
} from 'lucide-react';
import AnimatedCounter from './AnimatedCounter';
import { formatInr } from '../../utils/reconciliation/formatters';
import { cn } from '../../lib/utils';

const KPI_CONFIG = [
  {
    key: 'totalCredits',
    label: 'Total Credits',
    sub: 'Inbound payments',
    icon: ArrowDownLeft,
    accent: 'text-emerald-400',
    ring: 'border-emerald-500/35 bg-emerald-500/10',
    format: formatInr,
  },
  {
    key: 'totalDebits',
    label: 'Total Debits',
    sub: 'Outbound / usage',
    icon: ArrowUpRight,
    accent: 'text-rose-400',
    ring: 'border-rose-500/35 bg-rose-500/10',
    format: formatInr,
  },
  {
    key: 'netBalance',
    label: 'Net Balance',
    sub: 'Credits − debits',
    icon: TrendingUp,
    accent: 'text-de-gold',
    ring: 'border-de-gold/40 bg-de-gold/10',
    format: formatInr,
  },
  {
    key: 'failedCount',
    label: 'Failed Payments',
    sub: 'Requires review',
    icon: AlertTriangle,
    accent: 'text-amber-400',
    ring: 'border-amber-500/35 bg-amber-500/10',
    format: (n) => Math.round(n).toLocaleString('en-IN'),
  },
  {
    key: 'walletRecharge',
    label: 'Wallet Recharge',
    sub: 'Top-ups captured',
    icon: Wallet,
    accent: 'text-sky-400',
    ring: 'border-sky-500/35 bg-sky-500/10',
    format: formatInr,
  },
  {
    key: 'bookingAdvance',
    label: 'Booking Advances',
    sub: 'Advance collections',
    icon: Calendar,
    accent: 'text-violet-400',
    ring: 'border-violet-500/35 bg-violet-500/10',
    format: formatInr,
  },
];

function KpiCard({ cfg, value }) {
  const Icon = cfg.icon;
  return (
    <article className="recon-kpi-card">
      <div className="flex items-start justify-between gap-2">
        <span className={cn('recon-kpi-icon', cfg.ring)}>
          <Icon className={cn('h-4 w-4', cfg.accent)} />
        </span>
        <IndianRupee className="h-3.5 w-3.5 text-de-muted/50" />
      </div>
      <p className="recon-kpi-label">{cfg.label}</p>
      <p className={cn('recon-kpi-value tabular-nums', cfg.accent)}>
        <AnimatedCounter value={value} formatter={cfg.format} />
      </p>
      <p className="recon-kpi-sub">{cfg.sub}</p>
    </article>
  );
}

export default function ReconciliationKpiGrid({ summary }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
      {KPI_CONFIG.map((cfg) => (
        <KpiCard key={cfg.key} cfg={cfg} value={summary?.[cfg.key] ?? 0} />
      ))}
    </div>
  );
}
